import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import AllotVehicleModal from 'components/allotVehicleModel/AllotVehicleModal';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import { getAssignDriver, getTrip } from 'redux/actions/UserTrip';
import Loader from 'components/loader/Loader';
import { updateAssignDriver } from 'redux/actions/UserAllot';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import LocationDropdown from 'components/LocationDropdown/LocationDropdown';

function AssignTripView() {
  const dispatch = useDispatch();
  const [value, setValue] = useState('requested');
  const [openDialog, setOpenDialog] = useState(false);
  const [tripId, setTripId] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locationData, setLocationData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  // Redux selectors
  const assignDriverData = useSelector((state) => state?.userAssignDriver?.userAssignDriver?.data);
  const assignDriverLoader = useSelector((state) => state?.userAssignDriver?.loading);
  const trips = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
  const [filterDrivers, setFilterDrivers] = useState(assignDriverData);

  const id = localStorage.getItem('companyId');
  const userId = localStorage.getItem('ID');

  let filterData = {
    assignId: id,
    status: value,
    page: page,
    pageSize: rowsPerPage,
    type: "",
    location: selectedLocation?.id || ''
  };

  let filterDataDriver = {
    assignId: userId,
    status: 'assignTrip',
    page: "",
    pageSize: "",
    type: "",
    location: selectedLocation?.id || ''
  };

  useEffect(() => {
   // if (selectedLocation?.id) {
      dispatch(getTrip({ ...filterData, location: selectedLocation?.id }));
    //}
  }, [selectedLocation?.id, value, page, rowsPerPage]);

  useEffect(() => {
    setFilterDrivers(assignDriverData);
  }, [assignDriverData]);

  const onClickTableVendor = (data) => {
    if (value !== 'cancelled') {
      setTripId(data?.id);
      dispatch(getAssignDriver({ ...filterData,tripId: data?.id }));
      setLocationData(data);
      setOpenDialog(true);
      setSearchQuery("");
    }
  };

  const submittAssign = (data) => {
    const val = {
      tripId: tripId,
      driverId: data?.id,
      status: value,
      driverData: filterDataDriver,
      location: selectedLocation?.id || ''
    };
    dispatch(updateAssignDriver(val));
    handleClose();
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
    dispatch(getTrip({ ...filterData, location: selectedLocation?.id ,status:newValue}));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const handleLocationChange = (location) => {
    // No need to handle the location change here as it's managed by LocationDropdown component
   // console.log('Location changed:', location);
  };

  // Roles and permissions
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const assignRoleEnum = roleAndPermissionEnum.assign;

  const accessForall = handlePermissions(
    roleAndPermissions,
    assignRoleEnum.moduleKey,
    { defaultAllAccess: assignRoleEnum?.subModules?.assignTrip?.all }
  );

  const accessForAssign = handlePermissions(
    roleAndPermissions,
    assignRoleEnum.moduleKey,
    { customAccess: assignRoleEnum?.subModules?.assignTrip?.allot }
  );

  const assignBtnAccess = (accessForall || accessForAssign);

  return (
    <div className='h-[100%]'>
      <CommonBreadCrumb paths={[{ name: 'Assign Trip', url: '', className: 'colorBlue' }]} />
      {loader ? (
        <Loader />
      ) : (
        <Grid container>
          <Grid item className="tableContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item md={9}>
                    <TabList
                      className='minHeight32'
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }
                      }}
                       variant="scrollable"
                       scrollButtons="auto"
                    >
                      <Tab label="Requested" value="requested" className="tabStyle" />
                      <Tab label="Scheduled" value="scheduled" className="tabStyle" />
                      <Tab label="Assigned" value="assigned" className="tabStyle" />
                      <Tab label="Cancelled" value="cancelled" className="tabStyle" />
                    </TabList>
                  </Grid>
                  <Grid item xs={2} className="filter_menu">
                    <LocationDropdown
                      onChange={handleLocationChange}
                      className="location-dropdown"
                    />
                  </Grid>
                </Grid>

                <TabPanel value="requested" className="vendotTable">
                  <CommonTable
                    data={trips}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    assignBtnAccess={assignBtnAccess}
                    tabValue={value}
                  />
                </TabPanel>

                <TabPanel value="scheduled" className="vendotTable">
                  <CommonTable
                    data={trips}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    assignBtnAccess={assignBtnAccess}
                    tabValue={value} 
                  />
                </TabPanel>

                <TabPanel value="assigned" className="vendotTable">
                  <CommonTable
                    data={trips}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    assignBtnAccess={assignBtnAccess}
                    tabValue={value}
                  />
                </TabPanel>

                <TabPanel value="cancelled" className="vendotTable">
                  <CommonTable
                    data={trips}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    tabValue={value}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>
      )}

      {openDialog && (
        <AllotVehicleModal
          open={openDialog}
          toggle={setOpenDialog}
          tripDetails={locationData}
          allotData={filterDrivers}
          page={'listPage'}
          payload={filterData}
          submittAssign={submittAssign}
          loader={assignDriverLoader}
          locationData={locationData}
          value={value}
        />
      )}
    </div>
  );
}

export default AssignTripView;
